import { render, staticRenderFns } from "./OpenPurchaseOrdersTable.vue?vue&type=template&id=6debf059&"
import script from "./OpenPurchaseOrdersTable.vue?vue&type=script&lang=js&"
export * from "./OpenPurchaseOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports